import { apiCall, apiGet, apiPost } from './Api';

function urlBase64ToUint8Array(base64String) {
	const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
	const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
	const raw = atob(base64);
	const output = new Uint8Array(raw.length);
	for (let i = 0; i < raw.length; i++) {
		output[i] = raw.charCodeAt(i);
	}
	return output;
}

export function isStandaloneApp() {
	return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
}

export function isIos() {
	const ua = navigator.userAgent || '';
	return /iphone|ipad|ipod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

export function pushSupport() {
	const hasApi = 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
	if (hasApi) {
		return { ok: true, reason: '' };
	}
	if (isIos() && !isStandaloneApp()) {
		return {
			ok: false,
			reason: 'Agregá la app a la pantalla de inicio y abrila desde ahí para activar notificaciones.',
		};
	}
	return { ok: false, reason: 'Este navegador no puede recibir notificaciones.' };
}

function memberId() {
	const id = Number(window.App?.db?.member?.member_id);
	return Number.isFinite(id) && id > 0 ? id : 0;
}

async function postSubscription(subscription) {
	const id = memberId();
	if (!id) throw new Error('Sin sesión');
	return apiPost(`/member/${id}/push-subscription`, subscription.toJSON());
}

export async function syncPushSubscription() {
	const support = pushSupport();
	if (!support.ok) return { ok: false, reason: support.reason };
	if (Notification.permission !== 'granted') return { ok: false, reason: '' };
	if (!memberId() || !window.App?.auth?.token) return { ok: false, reason: '' };

	const registration = await navigator.serviceWorker.ready;
	const vapid = await apiGet('/push/vapid');
	const publicKey = vapid?.data?.publicKey;
	if (vapid?.class !== 'success' || !publicKey) {
		throw new Error(vapid?.html || 'Notificaciones no disponibles');
	}

	let subscription = await registration.pushManager.getSubscription();
	if (!subscription) {
		subscription = await registration.pushManager.subscribe({
			userVisibleOnly: true,
			applicationServerKey: urlBase64ToUint8Array(publicKey),
		});
	}
	const saved = await postSubscription(subscription);
	if (saved?.class !== 'success') {
		throw new Error(saved?.html || 'No se pudo guardar la suscripción');
	}
	return { ok: true, reason: '' };
}

export async function enablePushNotifications() {
	const support = pushSupport();
	if (!support.ok) return support;

	const permission = await Notification.requestPermission();
	if (permission !== 'granted') {
		return {
			ok: false,
			reason: permission === 'denied'
				? 'Las notificaciones están bloqueadas. Activalas en los ajustes del celular.'
				: 'No se activaron las notificaciones.',
		};
	}

	try {
		await syncPushSubscription();
		return { ok: true, reason: 'Notificaciones activadas en este dispositivo.' };
	} catch (error) {
		return { ok: false, reason: error?.message || 'No se pudieron activar las notificaciones.' };
	}
}

export async function removePushSubscription() {
	if (!('serviceWorker' in navigator) || !memberId() || !window.App?.auth?.token) return;
	const registration = await navigator.serviceWorker.getRegistration();
	const subscription = await registration?.pushManager?.getSubscription();
	if (!subscription) return;
	try {
		await apiCall(`/member/${memberId()}/push-subscription`, {
			method: 'DELETE',
			body: { endpoint: subscription.endpoint },
		});
	} catch (error) {
		console.warn('push unsubscribe', error);
	}
}
